module.exports = __webpack_public_path__ + "static/media/profileDefault.d088d287.jpg";